var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientContactCardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 1819,
    viewBox: "0 0 285 1819",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3315 422.753C84.9486 396.683 114.055 372.619 129.546 484.92C145.036 597.222 179.904 706.181 195.402 746.623C201.476 766.812 204.025 804.137 205.286 851.524C207.874 861.657 210.316 871.187 212.577 879.981L205.605 864.94C205.509 860.386 205.403 855.912 205.286 851.524C173.157 725.707 118.634 507.027 110.292 452.834C101.278 394.277 81.2291 408.381 72.3315 422.753Z",
    fill: "url(#paint0_linear_831_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 289.508V43.8481C38.945 -35.5651 53.3488 10.7593 55.6826 43.8481C82.2877 256.419 86.7511 436.569 85.6571 500.073C84.235 548.536 76.2491 607.361 55.6826 454.952C35.1161 302.543 9.99151 281.152 0 289.508Z",
    fill: "url(#paint1_linear_831_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.97 652.418V406.759C237.915 327.346 252.318 373.67 254.652 406.759C281.257 619.329 285.721 799.48 284.627 862.984C283.205 911.447 275.219 970.272 254.652 817.862C234.086 665.453 208.961 644.062 198.97 652.418Z",
    fill: "url(#paint2_linear_831_839)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.627 960.924V715.265C67.6823 635.852 53.2785 682.176 50.9447 715.265C24.3396 927.836 19.8762 1107.99 20.9702 1171.49C22.3923 1219.95 30.3783 1278.78 50.9447 1126.37C71.5112 973.959 96.6358 952.569 106.627 960.924Z",
    fill: "url(#paint3_linear_831_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 1338.73V1093.07C246.055 1013.66 231.651 1059.98 229.317 1093.07C202.712 1305.64 198.249 1485.79 199.343 1549.3C200.765 1597.76 208.751 1656.59 229.317 1504.18C249.884 1351.77 275.008 1330.38 285 1338.73Z",
    fill: "url(#paint4_linear_831_839)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.768 1372.27V1126.61C156.713 1047.19 171.117 1093.52 173.451 1126.61C200.056 1339.18 204.52 1519.33 203.426 1582.83C202.003 1631.3 194.017 1690.12 173.451 1537.71C152.885 1385.3 127.76 1363.91 117.768 1372.27Z",
    fill: "url(#paint5_linear_831_839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0493 1555.58V1309.92C50.9943 1230.51 65.3981 1276.83 67.7319 1309.92C94.337 1522.49 98.8004 1702.64 97.7064 1766.15C96.2843 1814.61 88.2984 1873.43 67.7319 1721.03C47.1655 1568.62 22.0408 1547.23 12.0493 1555.58Z",
    fill: "url(#paint6_linear_831_839)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_831_839",
    x1: 144.533,
    y1: 400.915,
    x2: 144.533,
    y2: 879.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_831_839",
    x1: 75.0457,
    y1: 395.793,
    x2: -1.43117,
    y2: 393.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_831_839",
    x1: 274.015,
    y1: 758.704,
    x2: 197.538,
    y2: 756.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_831_839",
    x1: 31.5816,
    y1: 1067.21,
    x2: 108.058,
    y2: 1065.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_831_839",
    x1: 209.954,
    y1: 1445.02,
    x2: 286.431,
    y2: 1443.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_831_839",
    x1: 192.814,
    y1: 1478.55,
    x2: 116.337,
    y2: 1476.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_831_839",
    x1: 87.095,
    y1: 1661.87,
    x2: 10.6181,
    y2: 1660.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientContactCardMobile);
export default __webpack_public_path__ + "static/media/gradient-contact-card-mobile.2b06328b1d2d0b4d4894110b9b48ad2c.svg";
export { ForwardRef as ReactComponent };